import { render, staticRenderFns } from "./CAs.vue?vue&type=template&id=b3565fbc&scoped=true&"
import script from "./CAs.vue?vue&type=script&lang=js&"
export * from "./CAs.vue?vue&type=script&lang=js&"
import style0 from "./CAs.vue?vue&type=style&index=0&id=b3565fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3565fbc",
  null
  
)

export default component.exports